module.exports = __webpack_public_path__ + "static/media/slider-home-service-slide-01-bg.2643a3a6.jpg";